/**
 * Inline error banner for a page's own load failure — the one error that has to
 * stay put, because the page has nothing else to show. A failed *mutation* is
 * never rendered inline: the query client toasts every one (lib/queryClient.ts),
 * so the layout doesn't jump as the message comes and goes.
 */
export function ErrorAlert({ message }: { message: string }) {
  return (
    <div className="rounded-md border border-destructive/50 bg-destructive/10 px-3 py-2 text-sm text-destructive">
      {message}
    </div>
  );
}
